var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',{ref:"item",attrs:{"config":{
    x: _vm.packet.path[0][0],
    y: _vm.packet.path[0][1],
    width: _vm.PACKET_CONFIG.RADIUS * 2,
    height: _vm.PACKET_CONFIG.RADIUS * 2,
    listening: false,
  }}},[_c('v-circle',{attrs:{"config":{
      ..._vm.defaultPacketConfig,
    }}}),_c('v-text',{attrs:{"config":{
    x: _vm.PACKET_CONFIG.RADIUS,
    y: _vm.PACKET_CONFIG.RADIUS,
    text: `${_vm.packet.taskCount}`,
    fill: _vm.PACKET_CONFIG.COLOR.DEFAULT,
    align: 'right',
    verticalAlign: 'bottom',
    fontSize: 10,
  }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }